import DOMPurify from 'dompurify'


const sanitize = html => DOMPurify.sanitize(html)

export default sanitize
